

import axios from "axios";
const instance = axios.create({ baseURL: "https://abcobranca-api.herokuapp.com" });
// const instance = axios.create({ baseURL: "http://localhost:8081" });


export default {
  state: {
    user: null,
    error: null,
    server: "https://abcobranca-api.herokuapp.com",
    // server: "http://localhost:8081",
    loadingError: false,
    desconto: false,
    chats : null,
    usuarios: [],
    handle: ''
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setDesconto (state, payload) {
      state.desconto = payload;
    },
    setError (state, payload) {
      state.error = payload;
    },
    SET_CHAT : (state,payload) => {
      state.chats = payload;
    },
    SET_USUARIOS: (state,payload) => {
      state.usuarios = payload;
    },
    ADD_CHAT : (state,payload) => {
      state.chats.push(payload);
    },
    SET_HANDLE : (state, payload)=> {
      state.handle = payload;
    }
    
  },
  actions: {
    SET_HANDLE : (context,payload)=> {
      context.commit('SET_HANDLE',payload);
    },
    SET_CHAT : async (context,payload) => {
      let {data} = await instance.get('/message/'+payload.path);
      context.commit("SET_CHAT",data);
    },
    SET_USUARIOS : async (context,payload) => {
      if (payload) {
        let data = await instance.get("/users/getallid/"+payload._id);
        if (payload.acesso == "Cliente") {
          data.data = data.data.filter((el) => {
            return el.acesso != "Cliente"
          });
        }
        context.commit("SET_USUARIOS",data.data);
      } else {
        context.commit("SET_USUARIOS",[]);
      }
      
    },
    ADD_CHAT : (context,payload)=> {
      context.commit("ADD_CHAT",payload);
    },
    async init ({commit}, payload) {
      
      /*firebase.getAuth().onAuthStateChanged((user) => {
        if (user) {
          commit('setUser', user)
        }
      })*/
      if (localStorage.getItem("cobranca-token")) {
        var token = localStorage.getItem("cobranca-token");
        var payload = JSON.parse(window.atob(token.split(".")[1]));
        await commit("setUser", payload);
      }
    },
    async signUserUp({ commit }, payload) {
      commit("setLoading", true);
      commit("clearError");
      await instance
        .post("/users/register", payload)
        .then(async user => {
          commit("setLoading", false);
          const newUser = {
            id: user.uid,
            name: payload.email,
            email: payload.email,
            photoUrl: user.photoURL
          };
          let userNew = JSON.parse(window.atob(user.data.token.split(".")[1]));
          localStorage.setItem("cobranca-token", user.data.token);
          commit("setUser", await userNew);
        })
        .catch(error => {
          commit("setLoading", false);
          commit("setError", error);
          console.log(error);
        });
      /*firebase.getAuth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )*/
    },
    async signUserIn({ commit }, payload) {
      try {
        commit("setLoading", true);
        commit("clearError");
        let user = await instance.post("/users/login", payload);
        commit("setLoading", false);
        let userNew = await JSON.parse(window.atob(user.data.token.split(".")[1]));
        localStorage.setItem("cobranca-token", user.data.token);
        commit("setUser", userNew);
      } catch (error) {
        error = "Usuário ou senha invalido!";
        commit("setLoading", false);
        commit("setError", error);
      };

    },
    signUserInGoogle ({commit}) {
      commit('setLoading', true)
      commit('clearError')
      firebase.getAuth().signInWithPopup(new firebase.getAuth().GoogleAuthProvider())
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    signUserInFacebook ({commit}) {
      commit('setLoading', true)
      commit('clearError')
      firebase.getAuth().signInWithPopup(new firebase.getAuth().FacebookAuthProvider())
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    signUserInGithub ({commit}) {
      commit('setLoading', true)
      commit('clearError')
      firebase.getAuth().signInWithPopup(new firebase.getAuth().GithubAuthProvider())
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    signUserInTwitter ({commit}) {
      commit('setLoading', true)
      commit('clearError')
      firebase.getAuth().signInWithPopup(new firebase.getAuth().TwitterAuthProvider())
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            }
            commit('setUser', newUser)
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    autoSignIn ({commit}, payload) {
      commit('setUser', {
        id: payload.uid,
        name: payload.displayName,
        email: payload.email,
        photoUrl: payload.photoURL
      })
    },
    desconto ({commit}, payload) {
      commit("setDesconto", payload.val);
    },
    logout ({commit}) {
      localStorage.removeItem("cobranca-token");
      
      commit("SET_USUARIOS", []);
      commit('drawerRight', false);
      commit("setUser", null);
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    server(state) {
      return state.server;
    },
    desconto(state) {
      return state.desconto;
    },
    CHATS : state => {
      return state.chats
    },
    usuarios : state => {
      return state.usuarios
    },
    HANDLE : state => {
      return state.handle
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user/index.js